import Rest from '../rest'

/******************************************************************************
 *  Reserves
 *****************************************************************************/

/**
 * @type {Reserves}
 */
export default class Reserves extends Rest {
    constructor () {
        super('/reserves/config')
    }

    getConfigGlobal(params) {
        return this.getAllV2('/global', params)
    }

    postConfigGlobal(data) {
        return this.createV2('/global', data)
    }

    getConfigLimitProduct(id, params) {
        return this.getAllV2(`/limit/product/${id}`, params)
    }

    postConfigLimitProduct(data) {
        return this.createV2('/limit', data)
    }
}